export class TalentIdLap {
    constructor({ number, lapTime, racingTime, isPersonalBest }) {
        this.number = number;
        this.lapTime = lapTime;
        this.racingTime = racingTime;
        this.isPersonalBest = isPersonalBest;
    }
}